import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { http } from "../../utils";

export async function fetchHospitalById(hospitalId) {
  const { data } = await http(`/admin/hospitals/${hospitalId}`);

  return data;
}

export function useHospitalById(ref) {
  const { data, ...raResult } = useQuery(["hospital-detail", ref], () =>
    fetchHospitalById(ref)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

async function deleteHospital(hospitalId) {
  const data = await http(`/admin/hospitals/${hospitalId}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteHospital() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteHospital, {
    onSuccess: () => {
      queryClient.invalidateQueries(["hospitals"]);
      navigate("/hospital");
    },
  });
}

// Point

export async function fetchHospitalPointById(hospitalId) {
  const { data } = await http(`/admin/hospital-points/${hospitalId}`);

  return data;
}

export function useHospitalPointById(ref) {
  const { data, ...raResult } = useQuery(["hospital-points", ref], () =>
    fetchHospitalPointById(ref)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
